import React, { useState } from 'react';
import { useAppContext } from '../../../Store/Store';

interface LinksScreenProps {
  onNext: () => void;
  navigateToProduct?: (productCode: string, preserveCustomerId?: boolean) => void;
  showSkipNextScreenButton?: boolean;
  showBackButton?: boolean;
  onBack?: () => void;
}

const LinksScreen: React.FC<LinksScreenProps> = ({
  onNext,
  navigateToProduct,
  showSkipNextScreenButton = false,
  showBackButton = false,
  onBack,
}) => {
  const { product, style } = useAppContext();
  const [selectedCode, setSelectedCode] = useState('');

  const linkOptions: { code: string; name: string }[] = product?.link_options || [];
  const displayAsButtons = product?.links_display_as_buttons !== false;

  const goToProduct = (code: string) => {
    if (!code) return;
    if (navigateToProduct) {
      navigateToProduct(code, false);
    }
  };

  if (linkOptions.length === 0) {
    return <div style={{ display: 'none' }} />;
  }

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        width: '100%',
        maxWidth: '1100px',
        margin: '0 auto',
        padding: '1.25rem',
        boxSizing: 'border-box',
        gap: '1rem',
        overflowY: 'auto',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {displayAsButtons ? (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '0.85rem',
            width: 'min(34vh, 90vw)',
            maxWidth: '420px',
          }}
        >
          {linkOptions.map(link => (
            <button
              key={link.code}
              type="button"
              onClick={() => goToProduct(link.code)}
              style={{
                height: '4.6vh',
                minHeight: '44px',
                width: '100%',
                borderRadius: '7px',
                padding: '0 20px',
                fontSize: '90%',
                fontWeight: 'bold',
                color: style?.text_review_button_text_color || '#07296A',
                background:
                  style?.text_review_button_bg_color ||
                  'linear-gradient(to right, #6991F8 0%, #07296a 100%)',
                border: 'none',
                cursor: 'pointer',
                boxShadow: '0 5px 5px ' + (style?.text_review_button_shadow_color || '#999'),
              }}
            >
              {link.name}
            </button>
          ))}
        </div>
      ) : (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '1rem',
            width: 'min(34vh, 90vw)',
            maxWidth: '420px',
          }}
        >
          <select
            value={selectedCode}
            onChange={e => setSelectedCode(e.target.value)}
            style={{
              width: '100%',
              height: '4.6vh',
              minHeight: '36px',
              borderRadius: '7px',
              padding: '0 20px',
              fontSize: '90%',
              border: '1px solid #ccc',
              background: '#f7f7f7',
              boxSizing: 'border-box',
            }}
          >
            <option value="">Select...</option>
            {linkOptions.map(link => (
              <option key={link.code} value={link.code}>
                {link.name}
              </option>
            ))}
          </select>

          <button
            type="button"
            onClick={() => goToProduct(selectedCode)}
            disabled={!selectedCode}
            style={{
              height: '4.6vh',
              minHeight: '44px',
              width: '100%',
              borderRadius: '7px',
              padding: '0 20px',
              fontSize: '90%',
              fontWeight: 'bold',
              color: style?.text_review_button_text_color || '#07296A',
              background: selectedCode
                ? style?.text_review_button_bg_color ||
                  'linear-gradient(to right, #6991F8 0%, #07296a 100%)'
                : '#c7c9cf',
              border: 'none',
              cursor: selectedCode ? 'pointer' : 'not-allowed',
              boxShadow: '0 5px 5px ' + (style?.text_review_button_shadow_color || '#999'),
            }}
            dangerouslySetInnerHTML={{
              __html: style?.text_review_send_button_indication || 'Continue',
            }}
          />
        </div>
      )}

      {showBackButton && (
        <button
          type="button"
          onClick={() => onBack?.()}
          style={{
            fontSize: '18px',
            textDecoration: 'underline',
            color: style?.back_button_text_color || '#07296A',
            background: 'transparent',
            border: 'none',
            cursor: 'pointer',
            alignSelf: 'center',
          }}
        >
          <span
            dangerouslySetInnerHTML={{
              __html: style?.back_button_indication || 'Back',
            }}
          />
        </button>
      )}

      {showSkipNextScreenButton && (
        <button
          type="button"
          onClick={onNext}
          style={{
            fontSize: '18px',
            textDecoration: 'underline',
            color: style?.skip_next_screen_button_text_color || '#07296A',
            background: 'transparent',
            border: 'none',
            cursor: 'pointer',
            alignSelf: 'center',
          }}
        >
          <span
            dangerouslySetInnerHTML={{
              __html: style?.skip_next_screen_button_indication || 'Skip',
            }}
          />
        </button>
      )}
    </div>
  );
};

export default LinksScreen;
